import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import { auth } from '../../firebase';
import { ReturnSignInLink } from './Links';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  error: null,
};

const styles = theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginLeft: theme.spacing.unit*4,
    marginRight: theme.spacing.unit*4,
    marginBottom: theme.spacing.unit*2,
  },
  button: {
    marginTop: theme.spacing.unit*4,
    marginBottom: theme.spacing.unit*4,
  },
  signIn: {
    alignSelf: "flex-end",
  },
});

class PasswordForgetForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const { email } = this.state;

    auth.doPasswordReset(email)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  render() {
    const {
      email,
      error,
    } = this.state;
    const { classes } = this.props;
    const isInvalid = email === '';

    return (
      <form className={classes.root} onSubmit={this.onSubmit}>
        <TextField
          label="Email Address"
          value={email}
          onChange={event => this.setState(byPropKey('email', event.target.value))}
          margin="normal"
        />
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          disabled={isInvalid}
          type="submit"
        >
          Reset My Password
        </Button>
        <div className={classes.signIn}><ReturnSignInLink /></div>
        { error && <p>{error.message}</p> }
      </form>
    );
  }
}

export default withStyles(styles)(PasswordForgetForm)



// WEBPACK FOOTER //
// ./src/components/auth/PasswordForgetForm.jsx